import _ from 'lodash'

import { AvatarHead } from '../Pieces/Head'
import styles from './../styles.module.scss'

export const AvatarPieceBase = ({
  name,
  STYLES,
  StyleComponent,
  style = '',
  color,
  inlineStyle = {},
  svgAttrs = {},
  withSvg,
  children,
  ...rest
}) => {
  const selectedStyle = _.get(STYLES, style)

  if (!selectedStyle) return <></>

  const SelectedStyleComponent = StyleComponent || selectedStyle

  if (withSvg)
    return (
      <svg
        style={inlineStyle}
        width="150"
        height="480"
        viewBox="0 0 150 480"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...svgAttrs}
        className={styles.Avatar}
      >
        {SelectedStyleComponent.Back && (
          <>
            <SelectedStyleComponent.Back color={color} {...rest} />
            <AvatarHead style="style1" />
          </>
        )}
        {['eyes', 'nose', 'mouth', 'beard'].includes(name) && (
          <AvatarHead style="style1" />
        )}
        <SelectedStyleComponent color={color} {...rest} />
      </svg>
    )

  return (
    <SelectedStyleComponent color={color} {...rest}>
      {children}
    </SelectedStyleComponent>
  )
}
